export default function RootPage() {
  return (
    <>
      <h1>iStart tools</h1>
      <p>This page only exists for ease of navigation during development.</p>
      <p>If you are not involved in the development of iStart and you've been directed to this page, please contact the iStart team so that we can repair the link that brought you here.</p>

      <h3>Keuzewijzer</h3>
      <a href="keuzewijzer">Keuzewijzer (EN)</a>
      <a href="keuzewijzer?language=nl">Keuzewijzer (NL)</a>
      <a href="keuzewijzer?language=fr">Keuzewijzer (FR)</a>

      <h3>BTW tool</h3>
      <a href="btwtool">BTW tool (EN)</a>
      <a href="btwtool?language=nl">BTW tool (NL)</a>
      <a href="btwtool?language=fr">BTW tool (FR)</a>

      <h3>Vennootschap of niet</h3>
      <a href="vennootschapofniet">Vennootschap of niet (EN)</a>
      <a href="vennootschapofniet?language=nl">Vennootschap of niet (NL)</a>
      <a href="vennootschapofniet?language=fr">Vennootschap of niet (FR)</a>
    </>
  )
}